import axios from "axios";
import { API_URL, ADMIN_API_URL, ORIGIN } from "../constant";

const headers = {
  "Accept": "application/json, text/plain, */*",
  "Accept-Language": "en-US,en;q=0.9,hi;q=0.8",
  "Content-Type": "application/json",
  "Origin": ORIGIN,
};

// Public Axios Instance
export const publicAxios = axios.create({
  baseURL: API_URL,
  headers,
});

// Admin Axios Instance
export const adminAxios = axios.create({
  baseURL: ADMIN_API_URL,
  headers: {
    "Accept": "application/json, text/plain, */*",
    "Content-Type": "application/json",
  },
});

// Axios Interceptor for Admin API
adminAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminToken");
    // Do not attach the Bearer token for login requests
    if (token && !config.url.includes("/auth/login")) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const API = {

  login: async (username, password) => {
    try {
      const response = await adminAxios.post("/auth/login", { username, password });
      return response.data;
    } catch (error) {
      console.error("API error in login:", error);
      throw error;
    }
  },

  logout: async () => {
    try {
      const response = await adminAxios.post("/auth/logout");
      return response.data;
    } catch (error) {
      console.error("API error in logout:", error);
      throw error;
    }
  },
};

export default API;
